{
	"shell": {
		"nav": "Your pages",
		"signOut": "Sign out",
		"tabs": {
			"profile": "Profile",
			"events": "My events",
			"medals": "My medals"
		}
	},
	"profile": {
		"title": "Profile",
		"photoAlt": "Your accreditation photo",
		"noPhoto": "No photo yet",
		"cardsTitle": "Your cards",
		"cardsHint": "Your organisation registers your cards. You can finish a card they started; ask them about anything else.",
		"noCards": "No cards yet.",
		"showProgress": "Show progress",
		"hideProgress": "Hide progress",
		"loadFailed": "Your profile could not be loaded.",
		"retry": "Try again",
		"contactTitle": "Contact details",
		"contactHint": "Only you and the Games organisers see these. Your name, ID and photo are changed by your organisation.",
		"emergencyTitle": "Emergency contact",
		"fields": {
			"email_address": "Email",
			"phone_country_code": "Country code",
			"phone_number": "Phone number",
			"residential_address": "Home address",
			"emergency_contact_name": "Name",
			"emergency_contact_relationship": "Relationship",
			"emergency_phone_country_code": "Country code",
			"emergency_phone_number": "Phone number"
		},
		"save": "Save changes",
		"saved": "Contact details saved.",
		"unchanged": "Nothing changed.",
		"stale": "Your details were changed somewhere else. The latest version is shown; make your change again.",
		"saveFailed": "Your contact details could not be saved.",
		"tiles": {
			"title": "At a glance",
			"nextUp": "Next up",
			"live": "Live now",
			"venueTbc": "Venue to be confirmed",
			"nothingScheduled": "Nothing scheduled yet",
			"medals": "Medals",
			"medal": {
				"GOLD_one": "{{count}} gold medal",
				"GOLD_other": "{{count}} gold medals",
				"SILVER_one": "{{count}} silver medal",
				"SILVER_other": "{{count}} silver medals",
				"BRONZE_one": "{{count}} bronze medal",
				"BRONZE_other": "{{count}} bronze medals"
			},
			"medalsTotal_one": "{{count}} medal",
			"medalsTotal_other": "{{count}} medals",
			"noMedals": "No medals yet",
			"loadFailed": "Could not load this."
		},
		"contact": {
			"edit": "Edit",
			"cancel": "Cancel",
			"notGiven": "Not given",
			"phone": "Phone"
		},
		"finish": {
			"title": "Finish your registration",
			"titleReturned": "Your organisation sent your registration back",
			"yours_one": "{{count}} thing left for you to add.",
			"yours_other": "{{count}} things left for you to add.",
			"orgOnly_one": "Your part is done. Your organisation still needs to add {{count}} thing.",
			"orgOnly_other": "Your part is done. Your organisation still needs to add {{count}} things.",
			"ready": "Everything is in. Check it and submit.",
			"button": "Continue registration",
			"rowLink": "Finish registration"
		}
	},
	"status": {
		"DRAFT": "Draft",
		"SUBMITTED": "Submitted",
		"PENDING": "Pending",
		"APPROVED": "Approved",
		"RETURN": "Returned",
		"REJECTED": "Rejected",
		"WITHDRAWN": "Withdrawn"
	},
	"events": {
		"title": "My events",
		"empty": "You are not entered in any event yet.",
		"emptyHint": "Your NOC enters you. Events appear here as soon as they do.",
		"loadFailed": "Your events could not be loaded.",
		"primary": "Primary",
		"reserve": "Reserve",
		"entered": "Entered",
		"noSchedule": "Not scheduled yet",
		"venueTbc": "Venue to be confirmed",
		"rank": "Rank {{rank}}",
		"cancelled": "Cancelled",
		"live": "Live",
		"official": "Official",
		"unofficial": "Unofficial",
		"previous": "Previous",
		"next": "Next",
		"pageOf": "Page {{page}} of {{pages}}",
		"retry": "Try again",
		"loadFailedHint": "Check your connection and try again.",
		"sessions_one": "{{count}} session",
		"sessions_other": "{{count}} sessions",
		"nextUp": "Next up",
		"postponed": "Postponed",
		"delayed": "Delayed",
		"interrupted": "Interrupted",
		"eventOfSport": "{{sport}}, {{event}}",
		"unscheduledHint": "Times appear here once the schedule is set."
	},
	"medals": {
		"title": "My medals",
		"empty": "No medals yet.",
		"emptyHint": "A medal shows here once it is awarded.",
		"loadFailed": "Your medals could not be loaded.",
		"GOLD": "Gold",
		"SILVER": "Silver",
		"BRONZE": "Bronze",
		"count_one": "{{count}} medal",
		"count_other": "{{count}} medals",
		"awardedOn": "Awarded {{date}}",
		"retry": "Try again",
		"loadFailedHint": "Check your connection and try again.",
		"tallyLabel": "Your medal tally",
		"total": "Total"
	},
	"registration": {
		"title": "Finish your registration",
		"cardLine": "{{games}}, {{category}}",
		"backToProfile": "Back to your profile",
		"loadFailed": "Your registration could not be loaded.",
		"notFound": {
			"title": "This registration could not be found",
			"body": "It may not be one of your cards. Go back to your profile and open it from there."
		},
		"stepsLabel": "Registration steps",
		"steps": {
			"contact": "Contact and medical",
			"travel": "Travel",
			"card": "Photo and card name",
			"review": "Review and submit"
		},
		"stepOf": "Step {{n}} of {{total}}: {{name}}",
		"stepOwes": "Something still to add",
		"stepHint": {
			"contact": "How the Games can reach you, who to call in an emergency, and what the medical team should know.",
			"travel": "When and how you arrive and leave. You can add this later if you do not know yet.",
			"card": "Your photo and the names printed on your card and in results.",
			"review": "Check everything, then submit it to your organisation."
		},
		"travelTyped": "Type your flight number, date and time as they are on your ticket.",
		"previous": "Back",
		"continue": "Continue",
		"saveContinue": "Save and continue",
		"unsaved": "Changes not saved yet",
		"saved": "Saved.",
		"saveFailed": "Your changes could not be saved",
		"submitFailed": "Your registration could not be submitted",
		"required": "Required",
		"invalid": "Check this value.",
		"contactFirst": "Add your email and mobile number first. They are needed before anything can be saved.",
		"neededToSubmit": "Needed to submit",
		"optional": "Optional",
		"stale": {
			"title": "This registration was changed somewhere else",
			"body": "The latest version is shown now. Check it and make your change again."
		},
		"closed": {
			"title": "Registration is closed",
			"body": "Your organisation's registration window is closed, so this card cannot be submitted now. What you saved is kept."
		},
		"returned": {
			"title": "Sent back to you",
			"body": "Your organisation returned this registration. Make the changes they asked for, then submit it again.",
			"remarkLabel": "What they asked you to change"
		},
		"leave": {
			"title": "Leave without saving?",
			"body": "Your changes on this page are not saved yet.",
			"stay": "Stay",
			"discard": "Leave"
		},
		"locked": {
			"title": "Your registration is with your organisation",
			"body": "It has been submitted. Your organisation and the host take it from here. If something needs to change, ask your organisation."
		},
		"submitted": {
			"title": "Submitted",
			"body": "Your organisation and the host take it from here. You can follow each step on your profile."
		},
		"review": {
			"allDone": "Everything needed is here. You can submit.",
			"yoursTitle_one": "{{count}} thing for you to add",
			"yoursTitle_other": "{{count}} things for you to add",
			"orgTitle_one": "{{count}} thing your organisation still needs to add",
			"orgTitle_other": "{{count}} things your organisation still needs to add",
			"orgHint": "You cannot change these. Ask your organisation to add them.",
			"add": "Add",
			"edit": "Edit",
			"editSection": "Edit {{section}}",
			"notGiven": "Not given",
			"missingValue": "Missing",
			"notAdded": "Not added yet",
			"yes": "Yes",
			"no": "No",
			"photo": "Photo",
			"tvPhoto": "TV photo",
			"noPhoto": "No photo",
			"submitHint": "Once you submit, you can no longer change these details here. Your organisation still can.",
			"notYet": "Submit becomes available once everything needed is added.",
			"savedOnSubmit": "Your unsaved changes are saved when you submit.",
			"submit": "Submit registration",
			"resubmit": "Submit again"
		},
		"missing": {
			"identification_number": "ID or passport number",
			"first_middle_name": "Name as on your ID",
			"gender": "Sex",
			"phone_number": "Mobile number",
			"email_address": "Email",
			"accreditation_name": "Name on your card",
			"sub_function_id": "Your function",
			"sport_id": "Your sport",
			"consent_truthfulness": "Declaration that the details are true",
			"consent_pdpa": "Data protection consent",
			"photo": "Accreditation photo"
		},
		"wording": {
			"contactNameHint": "The person to ask for when the Games call or write to you. Leave it empty to use your own name.",
			"travelLater": "You can add or change this until you submit. It is used for your airport welcome and transport.",
			"transferArrival": "From the entry point to your hotel or venue.",
			"transferDeparture": "From your hotel to the entry point.",
			"namesCard": "Name on your card",
			"nameOnCard": "Name on your card"
		},
		"photoSaveFirst": "Save your changes first, then add or change your photo.",
		"saveChanges": "Save changes",
		"declarations": {
			"title": "Your declarations",
			"truthfulness": "I declare that the details in this registration are true and complete.",
			"pdpa": "I agree that the Games organisers may process my personal data for accreditation, security and Games services.",
			"tickBoth": "Tick both declarations to submit."
		}
	}
}
